import type { ReactNode } from "react";
import {
  adminCardClass,
  adminCardHeaderClass,
  adminCardPaddingClass,
} from "./adminStyles";

type AdminCardProps = {
  children: ReactNode;
  title?: string;
  description?: string;
  header?: ReactNode;
  padding?: boolean;
  className?: string;
};

export default function AdminCard({
  children,
  title,
  description,
  header,
  padding = true,
  className = "",
}: AdminCardProps) {
  const showHeader = Boolean(title || description || header);

  return (
    <div className={`${adminCardClass} ${className}`.trim()}>
      {showHeader && (
        <div className={adminCardHeaderClass}>
          {header ?? (
            <div>
              {title && (
                <h2 className="text-base font-semibold text-gray-900 dark:text-white/90">
                  {title}
                </h2>
              )}
              {description && (
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
              )}
            </div>
          )}
        </div>
      )}
      <div className={padding ? adminCardPaddingClass : undefined}>{children}</div>
    </div>
  );
}
